export const isJapanese =
  window.location.hostname.includes("culinario-mortale.jp") || process.env.REACT_APP_LNG === "ja-JP";
